import request from '@/config/axios'

export interface FirmCalendarEventVO {
  id?: number
  eventType?: string
  editable?: boolean
  lawyerId?: number
  lawyerName?: string
  caseId?: number
  firmCaseNo?: string
  title?: string
  startTime?: string
  endTime?: string
  location?: string
  remark?: string
  conflictHint?: string
}

export interface FirmCalendarEventQuery {
  from: string
  to: string
  lawyerId?: number
}

export interface FirmCalendarEventSave {
  id?: number
  lawyerId: number
  eventType: string
  title: string
  startTime: string
  endTime: string
  remark?: string
}

export const FirmCalendarApi = {
  events: (params: FirmCalendarEventQuery) =>
    request.get<FirmCalendarEventVO[]>({ url: '/lawyer/firm/admin/calendar/events', params }),
  create: (data: FirmCalendarEventSave) =>
    request.post({ url: '/lawyer/firm/admin/calendar/create', data }),
  update: (data: FirmCalendarEventSave) =>
    request.put({ url: '/lawyer/firm/admin/calendar/update', data }),
  delete: (id: number) =>
    request.delete({ url: '/lawyer/firm/admin/calendar/delete?id=' + id })
}

export const CALENDAR_EVENT_TYPE_OPTIONS = [
  { value: 'LEAVE', label: '休假' },
  { value: 'OUT', label: '外出' }
]

export const calendarEventTypeLabel = (type?: string) => {
  if (type === 'HEARING') return '开庭'
  return CALENDAR_EVENT_TYPE_OPTIONS.find((o) => o.value === type)?.label || type || '-'
}
